import React from "react";
import { Button } from "antd";

const BrdgxButton = ({ onClick, title, style }) => (
  <Button
    type="primary"
    style={{ borderRadius: 3, width: "100%", fontWeight: 700, ...style }}
    onClick={onClick}
  >
    {title}
  </Button>
);

export default BrdgxButton;
